import React, { useContext, useState } from 'react';
import { AuthContext } from '../../app/auth/AuthContext';
import { useNavigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const login = async (username: string, password: string) => {
    const response = await fetch(`https://mlf10vrasj.execute-api.us-east-1.amazonaws.com/prod/login`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });

    if(!response.ok) {
      throw new Error('Login failed');
    }

    const { token } = await response.json();

    dispatch({ type: 'LOGIN_SUCCESS', payload: { token } });

    navigate('/gallery');
  };


  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    
    try {
      await login(username, password);
    } catch (error) {
      console.error('Login failed', error);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
      <h1>Login</h1>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="username" style={{ display: 'block', marginBottom: '5px' }}>Username:</label>
          <input
            type="text"
            id="username"
            name="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="password" style={{ display: 'block', marginBottom: '5px' }}>Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
        <button type="submit" style={{ padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>Login</button>
      </form>
    </div>
  );
};

export default LoginPage;
